import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Trash } from "@phosphor-icons/react";
import { STATUS_META } from "../constants";

export default function SousChantiersSection({ chantier, onChanged, isAdmin }) {
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState("");
  const [status, setStatus] = useState("waiting");

  const add = async () => {
    if (!name.trim()) return;
    await api.post(`/chantiers/${chantier.id}/sous`, { name, status, progress: 0 });
    setName(""); setStatus("waiting"); setAdding(false);
    onChanged();
  };
  const remove = async (sid) => {
    await api.delete(`/chantiers/${chantier.id}/sous/${sid}`);
    onChanged();
  };

  return (
    <div className="rounded-2xl bg-white/[0.03] border border-white/10 p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[11px] uppercase tracking-widest text-white/50">Sous-chantiers ({chantier.sous_chantiers?.length || 0})</div>
        {isAdmin && <button onClick={() => setAdding((v) => !v)} className="text-xs text-[#005CFF]" data-testid="add-sous-btn">+ Ajouter</button>}
      </div>
      {adding && (
        <div className="rounded-xl bg-white/5 border border-white/10 p-3 mb-3 space-y-2">
          <Input placeholder="Nom (ex: Électricité générale)" value={name} onChange={(e) => setName(e.target.value)} className="bg-white/5 border-white/10 h-10" data-testid="sous-name" />
          <Select value={status} onValueChange={setStatus}>
            <SelectTrigger className="bg-white/5 border-white/10 h-10"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-[#111] border-white/10 text-white">
              {Object.entries(STATUS_META).map(([k, m]) => <SelectItem key={k} value={k}>{m.label}</SelectItem>)}
            </SelectContent>
          </Select>
          <div className="flex gap-2">
            <Button variant="ghost" onClick={() => setAdding(false)} className="border border-white/10 flex-1">Annuler</Button>
            <Button onClick={add} className="bg-[#005CFF] hover:bg-[#0047CC] flex-1" data-testid="sous-save">Créer</Button>
          </div>
        </div>
      )}
      {!chantier.sous_chantiers?.length ? (
        <div className="text-xs text-white/40">Aucun sous-chantier</div>
      ) : (
        <div className="space-y-2">
          {chantier.sous_chantiers.map((sc) => {
            const m = STATUS_META[sc.status] || STATUS_META.waiting;
            return (
              <div key={sc.id} className="rounded-xl bg-white/[0.02] border border-white/5 p-3 group">
                <div className="flex items-center justify-between">
                  <div className="min-w-0 flex-1">
                    <div className="font-medium truncate">{sc.name}</div>
                    <div className="text-[10px] uppercase tracking-widest mt-0.5" style={{ color: m.color }}>{m.label}</div>
                  </div>
                  {isAdmin && (
                    <button onClick={() => remove(sc.id)} className="opacity-0 group-hover:opacity-100 text-white/40 hover:text-red-400"><Trash size={14} /></button>
                  )}
                </div>
                <div className="mt-2 h-1 bg-white/5 rounded-full overflow-hidden">
                  <div className="h-full" style={{ width: `${sc.progress || 0}%`, background: m.color }} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
